import { useState } from "react";
import { api, fmtBRL } from "@/lib/api";
import { MessageSquare, RefreshCw, AlertTriangle } from "lucide-react";
import { toast } from "sonner";

const TONE = {
  ok: { box: "border-[#1F293D] bg-[#111827]", accent: "#34D399", label: "Saldo OK" },
  warn: { box: "border-amber-500/50 bg-amber-500/10", accent: "#FBBF24", label: "Saldo baixo — recarregue em breve" },
  crit: { box: "border-red-500/60 bg-red-500/10", accent: "#F87171", label: "Saldo crítico — recarregue agora" },
};
const n = (v) => Number(v || 0).toLocaleString("pt-BR");

export const SmsBalanceCard = ({ balance, onRefresh }) => {
  const [busy, setBusy] = useState(false);
  if (!balance) return null;
  const t = TONE[balance.level] || TONE.ok;
  const refresh = async () => {
    setBusy(true);
    try { await api.post("/sms/balance/refresh"); await onRefresh(); toast.success("Saldo atualizado"); }
    catch { toast.error("Não foi possível consultar a SMS Mais"); }
    finally { setBusy(false); }
  };
  const checked = balance.checked_at ? new Date(balance.checked_at).toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" }) : "-";
  return (
    <div data-testid="sms-balance-card" data-level={balance.level} className={`rounded-2xl border p-4 fade-up ${t.box}`}>
      <div className="flex flex-wrap items-center gap-x-6 gap-y-3">
        <div className="flex items-center gap-3">
          <span className="rounded-lg p-2" style={{ background: `${t.accent}1A` }}>
            {balance.level === "ok" ? <MessageSquare className="h-5 w-5" style={{ color: t.accent }} /> : <AlertTriangle className="h-5 w-5" style={{ color: t.accent }} />}
          </span>
          <div>
            <div className="text-xs font-semibold uppercase tracking-wider text-slate-400">Saldo SMS Mais</div>
            <div data-testid="sms-balance-status" className="text-xs font-semibold" style={{ color: t.accent }}>{t.label}</div>
          </div>
        </div>
        <div className="flex items-baseline gap-2">
          <span data-testid="sms-balance-count" className="font-mono text-2xl font-extrabold text-white">{n(balance.saldo_sms)}</span>
          <span className="text-xs text-slate-400">SMS</span>
          <span data-testid="sms-balance-brl" className="font-mono text-sm text-slate-300">({fmtBRL(balance.saldo)})</span>
        </div>
        <div data-testid="sms-balance-days" className="text-sm text-slate-300">
          {balance.days_left != null ? <>dura ~<b className="font-mono text-white">{n(balance.days_left)}</b> dias</> : "sem consumo recente"}
          <span className="ml-1 text-xs text-slate-500">(média {n(balance.per_day)} SMS/dia)</span>
        </div>
        <div className="ml-auto flex items-center gap-3">
          <span data-testid="sms-balance-totals" className="text-[11px] text-slate-500">
            recarregado {fmtBRL(balance.total_recargas)} · gasto {fmtBRL(balance.total_consumo)} · às {checked}
          </span>
          <button data-testid="sms-balance-refresh" onClick={refresh} disabled={busy}
            className="rounded-lg border border-[#1F293D] bg-[#0F141F] p-1.5 text-slate-400 transition-colors hover:text-slate-100 disabled:opacity-50">
            <RefreshCw className={`h-4 w-4 ${busy ? "animate-spin" : ""}`} />
          </button>
        </div>
      </div>
      {balance.blocked && (
        <div data-testid="sms-balance-blocked" className="mt-3 rounded-lg border border-red-500/40 bg-red-500/10 px-3 py-2 text-xs text-red-200">
          Lote de SMS não enviado em {new Date(balance.blocked.at).toLocaleString("pt-BR")}: precisava de {n(balance.blocked.needed)} SMS e havia {n(balance.blocked.available)}. Recarregue e rode a régua de novo.
        </div>
      )}
    </div>
  );
};
